"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginPath = exports.getActionPath = exports.resolveActionPath = undefined;

var _constant = require("../constant");

var _constant2 = _interopRequireDefault(_constant);

var _platform = require("./platform");

var _platform2 = _interopRequireDefault(_platform);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// 解析 actionType 跳转路径
var resolveActionPath = exports.resolveActionPath = function resolveActionPath(_ref) {
  var actionType = _ref.actionType,
      actionData = _ref.actionData;

  // actionData = actionData //&& JSON.parse(actionData)
  switch (actionType) {
    case 1:
      return { path: "/" };
    case 2:
      return { path: "/", query: { redirect: actionData.url } };
    default:
      return "";
  }
};

//将resolveActionPath返回的路由对象解析成url字符串
var getActionPath = exports.getActionPath = function getActionPath(actionOption) {
  var _resolveActionPath = resolveActionPath(actionOption),
      path = _resolveActionPath.path,
      _resolveActionPath$qu = _resolveActionPath.query,
      query = _resolveActionPath$qu === undefined ? {} : _resolveActionPath$qu;

  var queryStr = "";
  // 需要跳外部链接的地址
  if (query.redirect) {
    return query.redirect;
  }
  for (var param in query) {
    queryStr += param + "=" + query[param] + "&";
  }
  return "" + _constant2.default.KAOP_MALL_HOST + path + "?" + queryStr.slice(0, -1);
};

var loginPath = exports.loginPath = function loginPath(url) {
  var toUrl = url || window.location.href;
  return _constant2.default.KAOP_MALL_HOST + "/auth/login?redirectUri=" + encodeURIComponent(toUrl);
};